import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBU21vAR8MsrmoD7RvLFa3tsElTaq7LVi0",
    authDomain: "tosstech-qa.firebaseapp.com",
    projectId: "tosstech-qa",
    storageBucket: "tosstech-qa.firebasestorage.app",
    messagingSenderId: "430528793285",
    appId: "1:430528793285:web:3690da250a7f1f7de2feac"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
